<template>
    <v-layout mt-5 column align-start justify-start d-flex fluid fill-height :style = '"width: " + ($vuetify.breakpoint.smAndUp? 75: 100 ) + "%; margin: auto;"'>
        <v-container fluid py-0>
            <template>
                <v-layout column fill-height class='mb-2 px-0'>
                    <v-card flat :style = '`overflow: hidden; box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`'>
                        <v-tabs 
                          v-model = 'activeTab' 
                          :slider-color = '$store.getters.uiAccent' 
                          :color = '$store.getters.uiAccent'
                          grow 
                          show-arrows
                          input='boundTabEvent' 
                          :value = 'activeTab'
                        >
                            <v-tab key='0' ripple class = 'mx-0'>Отчеты</v-tab>
<!--                            <v-tab key='1' ripple>Рекламные аккаунты</v-tab>-->
                            <v-tab key='4' ripple>Сбор данных</v-tab>
                            <v-tab key='2' ripple>Доступ</v-tab>
<!--                            <v-tab key='3' ripple>Настройки</v-tab>-->
                        </v-tabs>
                    </v-card>
                    <v-tabs-items v-model='activeTab' class = 'mt-3' :style = '`box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px; overflow: hidden;`'>
                        <v-tab-item  key='0'>
                            <v-card flat class='my-0'>
                                <v-card-text class = 'pa-0' style = 'border-radius: 4px;'>
                                    <project-reports-controller :data = 'currentProject'></project-reports-controller>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
<!--                        <v-tab-item  key='1'>-->
<!--                            <v-card flat class='my-0'>-->
<!--                                <v-card-text class = 'pa-0'>-->
<!--                                    <project-statplaces-controller :data = 'currentProject'></project-statplaces-controller>-->
<!--                                </v-card-text>-->
<!--                            </v-card>-->
<!--                        </v-tab-item>-->
                        <v-tab-item  key='4'>
                            <v-card flat>
                                <v-card-text>
                                    <project-datasources-controller :data = 'currentProject'></project-datasources-controller>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item  key='2'>
                            <v-card flat>
                                <v-card-text class='py-0'>
                                    <v-card tile flat>
                                        <v-card-text>
                                            <span :class = '`title font-weight-light ${!$vuetify.theme.dark? "black--text":""}`'>Доступ к проекту</span>
                                            <v-divider :color='$store.getters.uiAccent' class='my-1'></v-divider>
                                            <project-persons-controller :data='currentProject'></project-persons-controller>
                                            <span :class = '`title font-weight-light ${!$vuetify.theme.dark? "black--text":""}`'>Доступ к отчетам</span>
                                            <v-divider :color='$store.getters.uiAccent' class='my-1'></v-divider>
                                            <project-reports-grants-controller :data = 'currentProject'></project-reports-grants-controller>
                                        </v-card-text>
                                    </v-card>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
<!--                        <v-tab-item  key='3'>-->
<!--                            <v-card flat>-->
<!--                                <v-card-text>-->
<!--                                    <project-settings-controller :data = 'currentProject'></project-settings-controller>-->
<!--                                </v-card-text>-->
<!--                            </v-card>-->
<!--                        </v-tab-item>-->
                    </v-tabs-items>
                </v-layout>
            </template>
        </v-container>
    </v-layout>
</template>
<script>
import { orderBy } from 'lodash-es'

import ProjectReports from '@/components/entities/projects/Reports.vue';
import ProjectReportsGrants from '@/components/entities/projects/ReportsGrants.vue';
import ProjectStatplaces from '@/components/entities/projects/Statplaces.vue';
import ProjectPersons from '@/components/entities/projects/Persons.vue';
import ProjectSettings from '@/components/entities/projects/Settings.vue';
import ProjectWordStatplaces from '@/components/entities/projects/WordStatplaces.vue';
import ProjectDataSources from '@/components/entities/projects/DataSources.vue';

export default {
    components: {
        'project-reports-controller': ProjectReports,
        'project-reports-grants-controller': ProjectReportsGrants,
        'project-statplaces-controller': ProjectStatplaces,
        'project-wordstatplaces-controller': ProjectWordStatplaces,
        'project-datasources-controller': ProjectDataSources,
        'project-persons-controller': ProjectPersons,
        'project-settings-controller': ProjectSettings,
    },
    data() {
        return {
            activeTab: null
        }
    },
    methods: {
        requestProjectDetails() {
            this.activeTab = 0
            document.title = this.$store.getters.pageTitle + ' | ' + this.currentProject.project_name;
            this.$dataLayer.$emit('enrich', {
                event: 'navigation',
                data: {
                    title: document.title,
                    path: document.location.pathname
                },
                once: false
            })
        }
    },
    computed: {
        currentProject() {
            return this.$store.state.currentProject
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.name == 'project') {
                if (to && to.params && Object.keys(to.params).length > 1) {
                    this.$store.commit('cursorProject', to.params);
                } else {
                    const project = this.$store.getters.userObjects.filter((p) => p.project_id == to.params.project_id)[0]
                    this.$store.commit('cursorProject', project);
                }
                this.requestProjectDetails()
            }
        },
        currentProject() {
            if (Object.keys(this.currentProject).length) {
                this.$store.commit('setBreadcrumbs', [
                    { text: 'Главная', disabled: false, to: '/', ripple: true },
                    { text: this.currentProject.project_name, disabled: true, to: '/p/' + this.currentProject.project_id, ripple: true }
                ]);
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.subscribe((mutation, state) => {
                if (mutation.type == 'cursorProject') {
                    if (mutation.payload && Object.keys(mutation.payload).length > 0) {
                        vm.requestProjectDetails()
                    } else {
                        vm.$router.push({ 'path': '/' });
                    }
                }
            });
            if (from.name || Object.keys(to.params).includes('project_id')) {
                const project = vm.$store.getters.userObjects.filter((p) => p.project_id == to.params.project_id)[0]
                vm.$store.commit('cursorProject', project);
            }
        });
    },
    mounted() {
    }
}
</script>
